module.exports = __webpack_public_path__ + "static/media/my_assets_item_foot.7586a194.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/my_assets_item_foot.png
// module id = 163
// module chunks = 0 1